export default __webpack_public_path__ + "static/our-mission@2x-ba40d5ce669eb89c705ab7d236c9caff.png";